import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { LayoutUtilsService, MessageType } from '../../../../../../../core/_base/crud';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../../../../core/reducers';
import { ContactsService } from '../../../../../../../core/lists';
import { ResetContactCredentialComponent } from './reset-contact-credential/reset-contact-credential.component';
import { GeneralValidationMessagesService } from '../../../../../../../core/services/general-validation-messages.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'kt-contact-login',
  templateUrl: './contact-login.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactLoginComponent implements OnInit, OnDestroy {
  private subscriptions: any[] = [];
  contact;
  @Input() result;
  isViewMode = false;
  @Output() username = new EventEmitter<any>();
  loading = true;
  constructor(
    public dialog: MatDialog,
    private contactService: ContactsService,
    private router: Router,
    private layoutUtilsService: LayoutUtilsService,
    private store: Store<AppState>,
    private cdr: ChangeDetectorRef,
    private activateRoute: ActivatedRoute,
    private globalService: GeneralValidationMessagesService,
  ) {}

  ngOnInit() {
    this.isViewMode = this.activateRoute.url[`_value`][1]?.path === 'view';
    this.activateRoute.params.subscribe((params) => {
      if (params.id)
        this.globalService.getEntitiesById('contacts', params.id).subscribe((res) => {
          if (res) {
            this.contact = res.data;
            this.loading = false;
            this.cdr.detectChanges();
          }
        });
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach((el) => {
      if (el.sub) {
        el.sub.unsubscribe();
      }
    });
  }

  load(): any {
    this.contactService.getLoginHistory(this.contact.id).subscribe((resl) => {
      this.username.emit(resl.username);
      this.result = resl.username;
      this.cdr.detectChanges();
    });
    return this.result;
  }
  openResetDialog(resetPass) {
    const dialogRef = this.dialog.open(ResetContactCredentialComponent, {
      data: {
        username: resetPass ? this.load() : this.result.username,
        resetPass,
        contactId: this.contact.id,
      },
      width: '440px',
      height: 'auto',
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        const message = resetPass
          ? 'Your password reset successfully'
          : 'Your username changed successfully';
        this.layoutUtilsService.showActionNotification(
          message,
          MessageType.Read,
          6000,
          true,
          false,
        );
      }
      if (!resetPass) {
        this.load();
      }
    });
  }
  refresh() {
    this.contactService.getLoginHistory(this.contact.id).subscribe((res) => {
      this.username.emit(res.username);
      this.result = res.username;
      this.cdr.detectChanges();
    });
  }
}
